import { useMemo } from 'react'

import { useQuery } from '@connectrpc/connect-query'

import { listFloatingIndices } from '@enechain/eposition-proto/bffportal/v1/simulation_service-SimulationService_connectquery'

type FloatingIndexOption = { label: string; value: string }

export function useListFloatingIndices(enabled = true): FloatingIndexOption[] {
  const { data } = useQuery(listFloatingIndices, {}, { enabled })
  return useMemo(
    () =>
      (data?.items ?? []).map((item) => ({
        label: item.formula, // 燃調計算式を表示ラベルとして使用
        value: item.floatingIndexCode, // APIリクエストはcodeで送る
      })),
    [data],
  )
}
